import { isProdEnvironment } from 'utilities/environment';
import { STG_ENVIRONMENT } from 'constants/index';

export const ASSETS_HOST = isProdEnvironment() ? `assets.openbank.com` : `assets.${STG_ENVIRONMENT}.openbank.com`;

export const IMAGES_PATH = `https://${ASSETS_HOST}/web/images`;
